<template>
  <div>
    <div class="p-grid">
     

      <div class="p-col-4">
        <div  v-if="hayArchivo">
          <Button label="Cancelar fichero" icon="pi pi-times" @click="cancelarFichero" class="p-button-danger"/>
        </div>
        <div v-else>
          <FileUpload         
          name="contenido[]"
          mode="basic"
          v-bind:chooseLabel="$t('error_datos_seleccionar_fichero')" 
          :multiple="false"
          :auto="true"
          :customUpload="true"
          @uploader="myUploader"
        />      
        </div>
      </div> 

      <div class="p-col-4">
        <div  v-if="hayArchivo">
          <i>{{fichero.nombreFichero}}</i>
        </div>
        <div v-else>
          <i>{{ $t('error_datos_estudiante_fichero') }}</i>
        </div>
      </div>
    </div>

    

  </div>
</template>    

<script>
import Button from "primevue/button";
import FileUpload from "primevue/fileupload";

export default {
  components: {
    Button,
    FileUpload,
  },

  props: ["fichero"],

  data() {
    return {
      contenido: [],
      hayArchivo: false,
    };
  },

  methods: {
    myUploader(event) {
      
      let file = event.files[0];
      this.hayArchivo = true;
      let reader = new FileReader();
      let afichero = this.$props.fichero;
      console.log("fichero", file)
      // Listening when loading ends ...
      reader.onload = function (_e) {
        const base64 = _e.target.result;
        afichero.nombreFichero = file.name;
        afichero.fileContent = base64;
      };

      if (file) {
        // we read the data from our selected image to get the Base64
        reader.readAsDataURL(file);
      }
    },
    cancelarFichero(){
      this.hayArchivo = false;
      let afichero = this.$props.fichero;
      afichero.nombreFichero = null;
      afichero.fileContent = null;
    },

  },
};
</script>
